import createStore from "astrid-helpers/src/createStore";
export const [getRects, setRects, useRects] = createStore([]);
//# sourceMappingURL=rects.js.map